module.exports = __webpack_public_path__ + "img/1.795f95ba.png";